export const appHead = {"meta":[{"charset":"utf-8"},{"name":"google-site-verification","content":"gNicOKuKOLfsgcwXkyWCtufL8sFJhhfvgcKupSUus-I"},{"name":"yandex-verification","content":"06c959f31f45a467"},{"name":"validation-proxy","content":"rating-679a011f60e6b96608582c98"},{"name":"format-detection","content":"telephone=no"},{"name":"referrer","content":"strict-origin-when-cross-origin"},{"name":"cookie-policy","content":"same-site=none; secure"},{"name":"permissions-policy","content":"camera=(), microphone=(), geolocation=(), interest-cohort=()"},{"name":"third-party-cookies","content":"controlled"},{"http-equiv":"X-Content-Type-Options","content":"nosniff"},{"http-equiv":"X-XSS-Protection","content":"1; mode=block"},{"name":"theme-color","content":"#000000"},{"name":"color-scheme","content":"light dark"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico?v=3"},{"rel":"icon","type":"image/svg+xml","href":"/favicon.svg?v=3"},{"rel":"icon","media":"(prefers-color-scheme: dark)","href":"/favicon-dark.ico?v=3"},{"rel":"icon","type":"image/png","sizes":"192x192","href":"/android-chrome-192x192.png"},{"rel":"icon","type":"image/png","sizes":"512x512","href":"/android-chrome-512x512.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"preconnect","href":"https://www.google-analytics.com"},{"rel":"dns-prefetch","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://www.google-analytics.com"},{"rel":"preload","href":"/logo.svg","as":"image"},{"rel":"preload","href":"/sx/Cloud.png","as":"image"},{"rel":"preload","href":"/assets/fonts/alsHauss/ALSHauss-Regular.woff","as":"font","type":"font/woff","crossorigin":"anonymous"},{"rel":"preload","href":"/assets/fonts/alsHauss/ALSHauss-Medium.woff","as":"font","type":"font/woff","crossorigin":"anonymous"},{"rel":"preload","href":"/assets/fonts/alsHauss/ALSHauss-Bold.woff","as":"font","type":"font/woff","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://fonts.googleapis.com"},{"rel":"dns-prefetch","href":"https://cdnjs.cloudflare.com"},{"rel":"preload","href":"https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css","as":"style","crossorigin":"anonymous"}],"style":[],"script":[],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"